import { API } from "../../../services";
import { handleResponse } from "../../../helpers";
import { API_URL } from "../../../config/appConfig";

const basePath = `${API_URL.idp}/role`;

const tenantHeaders = (tenantId, extra = {}) => ({
  headers: {
    ...(tenantId ? { tenantId: String(tenantId).toLowerCase() } : {}),
    ...extra,
  },
});

const getAllTenantRoles = async (tenantId) => {
  return API.get(
    basePath,
    "tenant_roles_list",
    {},
    {},
    tenantHeaders(tenantId, { skipJsonContentType: true })
  ).then(handleResponse);
};

const getTenantRoleById = async (roleId, tenantId) => {
  if (!roleId) {
    throw new Error("Role id is missing.");
  }

  return API.get(
    basePath,
    "tenant_role_by_id",
    { roleId },
    {},
    tenantHeaders(tenantId, { skipJsonContentType: true })
  ).then(handleResponse);
};

const getTenantRoleByName = async (roleName, tenantId) => {
  if (!roleName) {
    throw new Error("Role name is missing.");
  }

  return API.get(
    `${basePath}/${encodeURIComponent(roleName)}`,
    "tenant_role_by_name",
    {},
    {},
    tenantHeaders(tenantId, { skipJsonContentType: true })
  ).then(handleResponse);
};

/** Postman: POST /role { name } only. Permissions are set via Update. */
const createTenantRole = async (payload = {}, tenantId) => {
  return API.post(
    basePath,
    "tenant_role_create",
    {
      name: String(payload.name || "").trim(),
    },
    tenantHeaders(tenantId)
  ).then(handleResponse);
};

const updateTenantRole = async (roleId, payload = {}, tenantId) => {
  if (!roleId) {
    throw new Error("Role id is missing.");
  }

  const permissions = Array.isArray(payload.permissions)
    ? payload.permissions
    : Array.isArray(payload.allow)
      ? payload.allow
      : [];

  return API.put(
    `${basePath}/${roleId}`,
    "tenant_role_update",
    {
      permissions: permissions.filter(Boolean).map(String),
    },
    tenantHeaders(tenantId)
  ).then(handleResponse);
};

const deleteTenantRole = async (roleId, tenantId) => {
  if (!roleId) {
    throw new Error("Role id is missing.");
  }

  return API.delete(
    `${basePath}/${roleId}`,
    "tenant_role_delete",
    {},
    tenantHeaders(tenantId, { skipJsonContentType: true })
  ).then(handleResponse);
};

export const tenantRoleService = {
  getAllTenantRoles,
  getTenantRoleById,
  getTenantRoleByName,
  createTenantRole,
  updateTenantRole,
  deleteTenantRole,
};
